import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemoveDuplicate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "-2 -2 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18 0H5V4H7V2H16V11H14V13H18V0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13 5H0V18H13V5ZM2 16V7H11V16H2Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.14286 11.5714L6.42857 10.2857L4.5 8.35714L3.21429 9.64286L5.14286 11.5714Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.42857 12.8571L7.71429 11.5714L6.42857 10.2857L5.14286 11.5714L6.42857 12.8571Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.64286 9.64286L8.35714 8.35714L6.42857 10.2857L7.71429 11.5714L9.64286 9.64286Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.35714 14.7857L9.64286 13.5L7.71429 11.5714L6.42857 12.8571L8.35714 14.7857Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.21429 13.5L4.5 14.7857L6.42857 12.8571L5.14286 11.5714L3.21429 13.5Z",
			fill: "white"
		})
	]
});
export default SvgRemoveDuplicate;
